import { z, ZodType, ZodTypeDef } from 'zod';

function deepFreeze<T>(obj: T): Readonly<T> {
    if (!(obj instanceof Object)) {
        return obj;
    }

    // Retrieve the property names defined on object
    const propNames = Reflect.ownKeys(obj);

    // Freeze properties before freezing self
    for (const name of propNames) {
        if (typeof name === 'symbol') {
            continue;
        }

        const value = Reflect.get(obj, name);

        if ((typeof value === 'object' || typeof value === 'function') && !Object.isFrozen(value)) {
            deepFreeze(value);
        }
    }

    return Object.freeze(obj);
}

// This `any` is needed so that `harden()` can correctly infer the return type when given any Zod
// schema.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyZodType = ZodType<any, ZodTypeDef, any>;

/**
 * Validate and freeze the givine data.
 *
 * @param zodDef - The Zod schema to validate.
 * @param value - The data to be validated.
 * @returns A readonly clone of the given data.
 */
export function harden<T extends AnyZodType>(zodDef: T, value: unknown): z.infer<Readonly<T>> {
    return deepFreeze(zodDef.parse(value));
}
